import auth0 from './auth0';

export function login(auth0) {
  return function execute() {
    const browserLanguage = navigator.language || 'en-CA';
    const lang = browserLanguage.match(/fr/) || location.search.match(/lang=fr/) ? 'fr-CA' : 'en-CA'; // eslint-disable-line
    auth0.authorize({
      flow: 'login',
      params: `lang=${lang}`,
    });
  };
}

export default login(auth0);
